import React from "react";
import { useEffect, useState } from "react";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

import DataTable from "examples/Tables/DataTable";

import { useDispatch, useSelector } from "react-redux";

import { areaColor } from "../../../config/enum";

import { getDevice } from "../../../api/devices";

import GaugeComponent from "react-gauge-component";

import { setCurrentDevices } from "../../../redux/reducers/devicesReducer";

export default function OrderCostingTable() {
  const currentDevices = useSelector((state) => state.devices.currentDevices);

  const currentOrder = useSelector((state) => state.orders.currentOrder);

  const dispatch = useDispatch();

  let [realGlobalAmount, setRealGlobalAmount] = useState(0);
  let [realBuyingsBudget, setRealBuyingsBudget] = useState(0);
  let [realHoursNumber, setRealHoursNumber] = useState(0);
  let [realWorkersCost, setRealWorkersCost] = useState(0);
  let [plannedHoursNumber, setPlannedHoursNumber] = useState(0);
  let [plannedWorkersCost, setPlannedWorkersCost] = useState(0);
  let [remainingHours, setRemainingHours] = useState(0);
  let [performance, setPerformance] = useState(0);
  let [efficiency, setEfficiency] = useState(0);
  let [forecastBuyingsBudget, setForecastBuyingsBudget] = useState(0);
  let [forecastHoursNumber, setForecastHoursNumber] = useState(0);
  let [forecastWorkersCost, setForecastWorkersCost] = useState(0);

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  async function fetchDevice(deviceId) {
    const response = await getDevice(deviceId);
    return await response.data;
  }

  const getDevices = async () => {
    if (currentOrder) {
      if (currentOrder.devices_ids) {
        const devices = [];
        const devices_id = currentOrder.devices_ids.split(",");
        for (let i = 0; i < devices_id.length; i++) {
          devices.push(await fetchDevice(devices_id[i]));
        }

        // Sort the devices array based on the device identifier
        devices.sort((a, b) => {
          // Extract the base device identifier (ignoring anything after a hyphen)
          const baseIdA = a.device_number.split(" -")[0];
          const baseIdB = b.device_number.split(" -")[0];

          // Compare the base identifiers
          if (baseIdA < baseIdB) return -1;
          if (baseIdA > baseIdB) return 1;

          // If base identifiers are equal, compare the full device_id to maintain relative order
          return a.device_number.localeCompare(b.device_number);
        });

        dispatch(setCurrentDevices(devices));
      }
    }
  };

  useEffect(() => {
    getDevices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrder]);

  async function fetchDevices() {
    if (currentDevices?.length > 0) {
      let globalAmountReal = 0;
      let buyingsBudgetReal = 0;
      let hoursNumberReal = 0;
      let workersCostReal = 0;
      let HoursNumberPlanned = 0;
      let plannedWorkersCost = 0;
      let remainingHourss = 0;
      let buyingsBudgetForecast = 0;
      let hoursNumberForecast = 0;
      let workersCostForecast = 0;
      for (let i = 0; i !== currentDevices.length; i++) {
        globalAmountReal += currentDevices[i].price;

        buyingsBudgetReal += currentDevices[i].real_purchases;

        hoursNumberReal += currentDevices[i].hours_past;

        workersCostReal += currentDevices[i].hours_past * currentOrder.area_hourly_rates;

        HoursNumberPlanned += currentDevices[i].hours_planned;

        plannedWorkersCost += currentDevices[i].hours_planned * currentOrder.area_hourly_rates;

        remainingHourss += currentDevices[i].hours_sold - currentDevices[i].hours_planned;

        buyingsBudgetForecast += currentDevices[i].purchases;

        hoursNumberForecast += currentDevices[i].hours_sold;

        workersCostForecast += currentDevices[i].hours_sold * currentOrder.area_hourly_rates;
      }
      setRealGlobalAmount(globalAmountReal);
      setRealBuyingsBudget(buyingsBudgetReal);
      setRealHoursNumber(hoursNumberReal);
      setRealWorkersCost(workersCostReal);
      setPlannedHoursNumber(HoursNumberPlanned);
      setPlannedWorkersCost(plannedWorkersCost);
      setRemainingHours(remainingHourss);
      setPerformance(
        (buyingsBudgetReal + workersCostReal) / (buyingsBudgetForecast + workersCostForecast)
      );
      setEfficiency(hoursNumberReal / hoursNumberForecast);
      setForecastBuyingsBudget(buyingsBudgetForecast);
      setForecastHoursNumber(hoursNumberForecast);
      setForecastWorkersCost(workersCostForecast);
    }
  }

  useEffect(() => {
    if (currentDevices) fetchDevices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDevices]);

  const orderCostingColumns = [
    { Header: "Chiffrage", accessor: "numeral", align: "center" },
    { Header: "Prix de vente de l'appareil", accessor: "device_amount", align: "center" },
    { Header: "Coût des achats", accessor: "buyings_budget", align: "center" },
    { Header: "Nombre d'heures", accessor: "hours", align: "center" },
    { Header: "Coût main d'oeuvre ", accessor: "hours_budget", align: "center", info: "workers" },
    { Header: "Efficacité", accessor: "eff", align: "center", info: "ratio" },
    { Header: "Performance", accessor: "perf", align: "center", info: "ratio" },
  ];

  const orderCostingRows = [
    {
      numeral: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          Prévisionnel
        </MDTypography>
      ),
      device_amount: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          -
        </MDTypography>
      ),
      buyings_budget: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          {forecastBuyingsBudget
            ? new Intl.NumberFormat("fr-FR").format(forecastBuyingsBudget) + " euros"
            : "Non spécifié"}
        </MDTypography>
      ),
      hours: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          {forecastHoursNumber
            ? new Intl.NumberFormat("fr-FR").format(forecastHoursNumber) + " heures"
            : "Non spécifié"}
        </MDTypography>
      ),
      hours_budget: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          {forecastWorkersCost
            ? new Intl.NumberFormat("fr-FR").format(forecastWorkersCost) + " euros"
            : "Non spécifié"}
        </MDTypography>
      ),
    },
    {
      numeral: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          Planifiée
        </MDTypography>
      ),
      device_amount: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          -
        </MDTypography>
      ),
      buyings_budget: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          -
        </MDTypography>
      ),
      hours: (
        <MDBox lineHeight={1}>
          <MDTypography component="a" variant="button" fontWeight="medium">
            {forecastHoursNumber !== null
              ? new Intl.NumberFormat("fr-FR").format(plannedHoursNumber && plannedHoursNumber) +
                " heures"
              : "Non spécifié"}
          </MDTypography>
          <MDTypography mt={0.15} display="block" variant="caption">
            {forecastHoursNumber && forecastHoursNumber !== null
              ? remainingHours >= 0
                ? "Il reste"
                : "Dépassement de"
              : ""}
          </MDTypography>
          <MDTypography
            color={remainingHours >= 0 ? "success" : "error"}
            mt={0.05}
            display="block"
            variant="string"
            fontWeight="medium"
          >
            {forecastHoursNumber && forecastHoursNumber !== null
              ? remainingHours >= 0
                ? new Intl.NumberFormat("fr-FR").format(remainingHours) +
                  `${remainingHours !== 0 && remainingHours !== 1 ? " heures" : " heure"}`
                : new Intl.NumberFormat("fr-FR").format(-1 * remainingHours) +
                  `${remainingHours !== 0 && remainingHours !== -1 ? " heures" : " heure"}`
              : "Non spécifié"}
          </MDTypography>
        </MDBox>
      ),
      hours_budget: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          {plannedWorkersCost !== null
            ? new Intl.NumberFormat("fr-FR").format(plannedWorkersCost && plannedWorkersCost) +
              " euros"
            : "Non spécifié"}
        </MDTypography>
      ),
      eff: (
        <MDBox sx={{ width: 200 + "px" }}>
          <GaugeComponent
            arc={{
              subArcs: [
                {
                  limit: 0.05,
                  color: "#004400", // Dark green
                },
                {
                  limit: 0.1,
                  color: "#005000", // Dark green
                },
                {
                  limit: 0.15,
                  color: "#005C00", // Dark green
                },
                {
                  limit: 0.2,
                  color: "#006800", // Dark green
                },
                {
                  limit: 0.25,
                  color: "#007400", // Dark green
                },
                {
                  limit: 0.3,
                  color: "#008000", // Dark green
                },
                {
                  limit: 0.35,
                  color: "#008C00", // Dark green
                },
                {
                  limit: 0.4,
                  color: "#009800", // Dark green
                },
                {
                  limit: 0.45,
                  color: "#00A400", // Dark green
                },
                {
                  limit: 0.5,
                  color: "#00B000", // Dark green
                },
                {
                  limit: 0.55,
                  color: "#00BC00", // Dark green
                },
                {
                  limit: 0.6,
                  color: "#00C800", // Dark green
                },
                {
                  limit: 0.65,
                  color: "#00D400", // Dark green
                },
                {
                  limit: 0.7,
                  color: "#00E000", // Dark green
                },
                {
                  limit: 0.75,
                  color: "#00EC00", // Dark green
                },
                {
                  limit: 0.8,
                  color: "#00F800", // Almost pure green
                },
                {
                  limit: 0.85,
                  color: "#00FF00", // Pure green
                },
                {
                  limit: 0.9,
                  color: "#00FF00", // Pure green
                },
                {
                  limit: 0.95,
                  color: "#4CFF4C", // Slightly lighter green
                },
                {
                  limit: 1,
                  color: "#66FF66", // Slightly lighter green
                  showTick: true,
                },
                {
                  limit: 1.05,
                  color: "#FFEE00", // Yellow
                },
                {
                  limit: 1.1,
                  color: "#FFCF00", // Darker yellow
                },
                {
                  limit: 1.15,
                  color: "#FFA500", // Orange
                },
                {
                  limit: 1.2,
                  color: "#FF8000", // Darker orange
                },
                {
                  limit: 1.25,
                  color: "#FF4500", // Red-orange
                },
                {
                  limit: 1.3,
                  color: "#FF0000", // Red
                },
              ],
            }}
            id={"eff-gauge-" + darkMode}
            minValue={0}
            maxValue={1.3}
            value={
              forecastHoursNumber !== null &&
              forecastHoursNumber !== 0 &&
              realHoursNumber !== null &&
              realHoursNumber !== 0
                ? efficiency
                : 0
            }
            style={{
              margin: "0 auto",
              width: 250 + "px",
              position: "absolute",
              left: 0,
              right: 0,
              top: -48.935,
            }}
            labels={{
              valueLabel: {
                /* matchColorWithArc: true, */
                style: {
                  fontSize: "35px",
                  fill: darkMode ? "white" : "#344767",
                  textShadow: "none",
                  fontWeight: "bold",
                  textAnchor: "middle",
                },
              },
            }}
          />
        </MDBox>
      ),
      perf: (
        <MDBox sx={{ width: 200 + "px" }}>
          <GaugeComponent
            arc={{
              subArcs: [
                {
                  limit: 0.05,
                  color: "#004400", // Dark green
                },
                {
                  limit: 0.1,
                  color: "#005000", // Dark green
                },
                {
                  limit: 0.15,
                  color: "#005C00", // Dark green
                },
                {
                  limit: 0.2,
                  color: "#006800", // Dark green
                },
                {
                  limit: 0.25,
                  color: "#007400", // Dark green
                },
                {
                  limit: 0.3,
                  color: "#008000", // Dark green
                },
                {
                  limit: 0.35,
                  color: "#008C00", // Dark green
                },
                {
                  limit: 0.4,
                  color: "#009800", // Dark green
                },
                {
                  limit: 0.45,
                  color: "#00A400", // Dark green
                },
                {
                  limit: 0.5,
                  color: "#00B000", // Dark green
                },
                {
                  limit: 0.55,
                  color: "#00BC00", // Dark green
                },
                {
                  limit: 0.6,
                  color: "#00C800", // Dark green
                },
                {
                  limit: 0.65,
                  color: "#00D400", // Dark green
                },
                {
                  limit: 0.7,
                  color: "#00E000", // Dark green
                },
                {
                  limit: 0.75,
                  color: "#00EC00", // Dark green
                },
                {
                  limit: 0.8,
                  color: "#00F800", // Almost pure green
                },
                {
                  limit: 0.85,
                  color: "#00FF00", // Pure green
                },
                {
                  limit: 0.9,
                  color: "#00FF00", // Pure green
                },
                {
                  limit: 0.95,
                  color: "#4CFF4C", // Slightly lighter green
                },
                {
                  limit: 1,
                  color: "#66FF66", // Slightly lighter green
                  showTick: true,
                },
                {
                  limit: 1.05,
                  color: "#FFEE00", // Yellow
                },
                {
                  limit: 1.1,
                  color: "#FFCF00", // Darker yellow
                },
                {
                  limit: 1.15,
                  color: "#FFA500", // Orange
                },
                {
                  limit: 1.2,
                  color: "#FF8000", // Darker orange
                },
                {
                  limit: 1.25,
                  color: "#FF4500", // Red-orange
                },
                {
                  limit: 1.3,
                  color: "#FF0000", // Red
                },
              ],
            }}
            // 201.73px & 131.17px
            id={"perf-gauge-" + darkMode}
            minValue={0}
            maxValue={1.3}
            value={
              realBuyingsBudget !== null &&
              realBuyingsBudget !== 0 &&
              realWorkersCost !== null &&
              realWorkersCost !== 0 &&
              forecastBuyingsBudget !== null &&
              forecastBuyingsBudget !== 0 &&
              forecastWorkersCost !== null &&
              forecastWorkersCost !== 0
                ? performance
                : 0
            }
            style={{
              margin: "0 auto",
              width: 250 + "px",
              position: "absolute",
              left: 0,
              right: 0,
              top: -48.935,
            }}
            labels={{
              valueLabel: {
                /* matchColorWithArc: true, */
                style: {
                  fontSize: "35px",
                  fill: darkMode ? "white" : "#344767",
                  textShadow: "none",
                  fontWeight: "bold",
                  textAnchor: "middle",
                },
              },
            }}
          />
        </MDBox>
      ),
    },
    {
      numeral: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          Réel
        </MDTypography>
      ),
      device_amount: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          {realGlobalAmount
            ? new Intl.NumberFormat("fr-FR").format(realGlobalAmount) + " euros"
            : "Non spécifié"}
        </MDTypography>
      ),
      buyings_budget: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          {realBuyingsBudget
            ? new Intl.NumberFormat("fr-FR").format(realBuyingsBudget) + " euros"
            : "Non spécifié"}
        </MDTypography>
      ),
      hours: (
        <MDBox lineHeight={1}>
          <MDTypography display="block" variant="string" fontWeight="medium" mb={0.25}>
            {realHoursNumber
              ? new Intl.NumberFormat("fr-FR").format(realHoursNumber) + " heures"
              : "Non spécifié"}
          </MDTypography>
        </MDBox>
      ),
      hours_budget: (
        <MDBox lineHeight={1}>
          <MDTypography display="block" variant="string" fontWeight="medium" mb={0.25}>
            {realWorkersCost
              ? new Intl.NumberFormat("fr-FR").format(realWorkersCost) + " euros"
              : "Non spécifié"}
          </MDTypography>
        </MDBox>
      ),
    },
  ];

  return (
    <Grid item xs={12} mt={6} mb={3}>
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          style={{
            backgroundColor: currentOrder && areaColor[currentOrder.area],
            boxShadow: `0 1px 4px 1px ${currentOrder && areaColor[currentOrder.area]}`,
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <MDTypography
            variant="h5"
            style={{
              lineHeight: "2.4rem",
              display: "tableCell",
              verticalAlign: "middle",
            }}
            color="white"
          >
            Chiffrage de la commande
          </MDTypography>
        </MDBox>
        <MDBox pt={0.75}>
          <DataTable
            table={{ columns: orderCostingColumns, rows: orderCostingRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>
      </Card>
    </Grid>
  );
}
